import React from 'react';
import { FaTachometerAlt, FaArrowLeft, FaTint, FaFileContract, FaCheckCircle, FaUserShield } from 'react-icons/fa';

export const NosotrosView = () => (
  <div className="animate-fade-in">
    {/* HERO INSTITUCIONAL */}
    <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 overflow-hidden">
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
      <div className="absolute top-20 right-10 w-72 h-72 bg-cyan-400 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6 drop-shadow-md leading-tight">
          Institucional
        </h1>
        <p className="mt-4 text-xl md:text-2xl max-w-3xl mx-auto text-blue-100 font-light leading-relaxed">
          Tecnología y Transparencia en la Gestión de Agua
        </p>
      </div>
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg
          className="relative block w-full h-[80px] md:h-[120px]"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-gray-50"
          ></path>
        </svg>
      </div>
    </section>

    {/* CONTENIDO PRINCIPAL */}
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
        <section className="bg-blue-50 rounded-3xl p-8 border border-blue-100 text-center">
          <FaTachometerAlt className="text-5xl text-blue-600 mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-blue-900 mb-4">
            Nuestra Misión
          </h3>
          <p className="text-gray-700 leading-relaxed text-lg max-w-3xl mx-auto">
            AquaGestión es una iniciativa impulsada por{" "}
            <strong>Poli Devs</strong> para modernizar las Juntas de
            Agua Potable. Nuestra misión es brindar herramientas
            tecnológicas que garanticen transparencia, eficiencia y
            cercanía con el socio.
          </p>
        </section>

        {/* POLIDEVS PROFILE SECTION */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/polidevs.png"
                alt="Polidevs Logo"
                className="h-10 w-auto object-contain"
              />
              <h3 className="text-2xl font-black text-blue-900 uppercase tracking-tighter">
                Poli Devs
              </h3>
            </div>
            <p className="text-gray-600 leading-relaxed mb-6 font-medium">
              Somos una empresa tecnológica ecuatoriana especializada en
              transformar negocios y comunidades a través del desarrollo
              de software a medida, facturación electrónica y soluciones
              e-commerce de alto impacto.
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100">
                <h4 className="font-bold text-blue-600 text-sm mb-1 italic">
                  Software
                </h4>
                <p className="text-[10px] text-gray-500 uppercase font-black">
                  App Web & Mobile
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100">
                <h4 className="font-bold text-blue-600 text-sm mb-1 italic">
                  Academy
                </h4>
                <p className="text-[10px] text-gray-500 uppercase font-black">
                  Formación Tech
                </p>
              </div>
            </div>
            <a
              href="https://polidevs.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-8 text-blue-600 font-black hover:underline group"
            >
              Visitar polidevs.com{" "}
              <FaArrowLeft className="rotate-180 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
          <div className="bg-gradient-to-br from-blue-900 to-blue-600 rounded-[40px] p-10 text-white shadow-2xl relative overflow-hidden group">
            <FaTint className="absolute -bottom-10 -right-10 text-[200px] opacity-10 group-hover:scale-110 transition-transform duration-700" />
            <h3 className="text-xl font-bold mb-4">
              Liderazgo Tecnológico
            </h3>
            <p className="text-blue-100/80 text-sm leading-relaxed mb-6">
              A través de <strong>Poli Devs Academy</strong>, fomentamos
              el crecimiento del talento digital en el país, capacitando
              a la próxima generación de desarrolladores FullStack y
              expertos en IA.
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-cyan-400"></div>
              <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
                Impulsando el Futuro
              </span>
            </div>
          </div>
        </section>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-8">
          <section className="bg-white rounded-3xl p-8 border border-gray-100 shadow-md">
            <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-3">
              <FaFileContract className="text-blue-600" /> Términos y
              Condiciones
            </h3>
            <ul className="space-y-4 text-gray-600 font-medium text-sm">
              <li className="flex items-start gap-3">
                <FaCheckCircle className="text-green-500 mt-1" />
                <span>
                  Uso exclusivo para la gestión comunitaria de agua
                  potable.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <FaCheckCircle className="text-green-500 mt-1" />
                <span>
                  Protección legal de la propiedad intelectual de la
                  plataforma.
                </span>
              </li>
            </ul>
          </section>
          <section className="bg-white rounded-3xl p-8 border border-gray-100 shadow-md">
            <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-3">
              <FaUserShield className="text-blue-600" /> Política de
              Privacidad
            </h3>
            <ul className="space-y-4 text-gray-600 font-medium text-sm">
              <li className="flex items-start gap-3">
                <FaCheckCircle className="text-blue-500 mt-1" />
                <span>
                  Confidencialidad absoluta de los datos de consumo de
                  los socios.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <FaCheckCircle className="text-blue-500 mt-1" />
                <span>
                  Cumplimiento con estándares internacionales de
                  ciberseguridad.
                </span>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </section>
  </div>
);
